export enum StoreKeys {
  SelectedAddress = 'selectedAddress',
  SelectedLocation = 'selectedLocation',
  SelectedTimeslot = 'selectedTimeslot',
  ContactInfo = 'contactInfo',
  BookedAppointment = 'bookedAppointment',
  CancellationDetails = 'cancellationDetails'
}
